import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTransferVoucherNo,
  createTransferEntry,
  fetchOtherBranchList,
  fetchTransferById,
} from "./TransferEntryThunk";
import { currentDateTime } from "../../lib/functions";

const emptyRow = (i = 1) => ({
  key: `t-${i}`,
  item_id: null,
  product: "",
  quantity: 0,
  rate: 0,
  current_qty: 0,
});

const initialState = {
  voucherNo: "",
  itemsList: [emptyRow()],
  isEdit: false,
  footerValues: {
    subTotal: 0,
    serviceCharge: 0,
    grandTotal: 0,
    narration: "",
    paidAmount: 0,
    dueAmount: 0,
  },
  success: null,
  loading: false,
  branches: [],
  branchDetails: {
    id: null,
    name: "",
    address: "",
  },
  warehouse: null,
  entryDate : currentDateTime()
};

const transferEntrySlice = createSlice({
  name: "transferEntry",
  initialState,
  reducers: {
    setResetTransfer(state) {
      state.isEdit = false;
      state.t_id = null;
      state.itemsList = [emptyRow()];
      state.footerValues = {
        subTotal: 0,
        serviceCharge: 0,
        grandTotal: 0,
        narration: "",
        paidAmount: 0,
        dueAmount: 0,
      };
      state.success = null;
      state.branches = [];
      state.branchDetails = {
        id: null,
        name: "",
        address: "",
      };
      state.warehouse = null;
      state.entryDate = new Date().toISOString();
    },
    setFormField(state, action) {
      const { field, value } = action.payload;
      state[field] = value;
    },
    addTransferRow(state) {
      state.itemsList.push(emptyRow(state.itemsList.length + 1));
    },
    deleteTransferRow(state, action) {
      state.itemsList = state.itemsList.filter((r) => r.key !== action.payload);
      if (!state.itemsList.length) state.itemsList = [emptyRow()];
    },
      updateTransferRow(state, action) {
      const { key, data } = action.payload;
      const row = state.itemsList.find((r) => r.key === key);
      if (row) {
        Object.assign(row, data);
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransferVoucherNo.fulfilled, (state, action) => {
        state.voucherNo = action.payload;
      })
      .addCase(fetchOtherBranchList.fulfilled, (state, action) => {
        state.branches = action.payload;
      })
      .addCase(createTransferEntry.fulfilled, (state, action) => {
        state.success = action.payload;
      })
      .addCase(fetchTransferById.fulfilled, (state, action) => {
        const master = action.payload;

        state.t_id = master.t_id;
        state.isEdit = true;
        state.voucherNo = master.t_voucher_no;
        state.entryDate = master.created_date;

        state.branchDetails = {
          id: master.to_branch_id,
          name: master.to_branch_name,
          address: master.to_branch_address,
          margin: master.details?.[0]?.margin_rate || 0
        };

        state.footerValues = {
          subTotal: master.sub_total || 0,
          serviceCharge: master.total_transport_cost || 0,
          grandTotal: master.total_amount || 0,
          narration: master.narration || "",
          paidAmount: 0,
          dueAmount: 0,
        };

        state.itemsList = master.details.map((d, index) => ({
          key: `t-${index + 1}`,
          item_id: d.item_id,
          product: d.item_name,
          quantity: d.item_qty,
          rate: d.item_rate,
          unit_name: d.unit_name,
          conversion: d.conversion,
          retail_qty: d.retail_qty,
          per_unit_id: d.per_unit_id,
          serials: d.serials
            ? d.serials.split(",").map(s => ({ serial_number: s }))
            : [],
          margin: d.margin_rate || 0,
          base_rate: d.base_rate || 0,
        }));
      });

        },
      });

export const {
  setResetTransfer,
  setFormField,
  addTransferRow,
  deleteTransferRow,
  updateTransferRow
} = transferEntrySlice.actions;

export default transferEntrySlice.reducer;
